export const palette = [
  '#E95263',
  '#3EC7E0',
  '#7C4EBB',
  '#18C8B5',
  '#16B8A6',
  '#EDBC4D',
  '#38B5CD',
  '#051B5B',
  '#CB5263',
  '#8B57D1'
];
export const states = [
  {
    left: {
      it: 'facciamo',
      en: 'conduct'
    },
    right: {
      it: 'ricerca',
      en: 'research'
    },
    image: {
      desktop: '/images/cover/facciamo-ricerca-desktop.jpg',
      mobile: '/images/cover/facciamo-ricerca-mobile.jpg'
    }
  },
  {
    left: {
      it: 'sperimentiamo',
      en: 'test'
    },
    right: {
      it: 'idee',
      en: 'ideas'
    },
    image: {
      desktop: '/images/cover/sperimentiamo-idee-desktop.jpg',
      mobile: '/images/cover/sperimentiamo-idee-mobile.jpg'
    }
  },
  {
    left: {
      it: 'proponiamo',
      en: 'practice'
    },
    right: {
      it: 'politiche',
      en: 'advocacy'
    },
    image: {
      desktop: '/images/cover/proponiamo-politiche-desktop.jpg',
      mobile: '/images/cover/proponiamo-politiche-mobile.jpg'
    }
  },
  {
    left: {
      it: 'costruiamo',
      en: 'build'
    },
    right: {
      it: 'progetti',
      en: 'projects'
    },
    image: {
      desktop: '/images/cover/costruiamo-progetti-desktop.jpg',
      mobile: '/images/cover/costruiamo-progetti-mobile.jpg'
    }
  },
  {
    left: {
      it: 'sosteniamo',
      en: 'support'
    },
    right: {
      it: 'il sociale',
      en: 'society'
    },
    image: {
      desktop: '/images/cover/sosteniamo-il-sociale-desktop.jpg',
      mobile: '/images/cover/sosteniamo-il-sociale-mobile.jpg'
    }
  },
  {
    left: {
      it: 'generiamo',
      en: 'generate'
    },
    right: {
      it: 'valore',
      en: 'value'
    },
    image: {
      desktop: '/images/cover/generiamo-valore-desktop.jpg',
      mobile: '/images/cover/generiamo-valore-mobile.jpg'
    }
  }
];
